
export const types = {
  loadingShow: '[Loading] Show Loading',
  headersSetAuth: '[Headers] Set Auth', 
  loginSetTokens: '[Login] Set Access and Refresh Token',
  textsSetValues: "[Texts] Set Values",
}
